import { getProjectData } from 'Services/WeaverUtils'
import { setUserAcls, setUserRoles } from 'Actions/user'
import { store } from '~/Store'

WRITE_ACCESS = 'project_write_access'

class ACL_Service

  constructor: ->
    @userAcls = []
    @projectAcls = []
    @userRoles = []

  discoverPermissions: ->
    await @getProjectAcls()
    await @determineUserAcls()
    @determineUserRoles()

  loadUserAclPermissions: ->
    aclIds = [
      'project-administration',
      'user-administration',
      'acl-administration',
      'role-administration'
    ]
    for id in aclIds
      try
        acl = await Weaver.ACL.load(id)
        if (acl.id() and @userAcls.indexOf(acl.id()) is -1) then @userAcls.push(acl.id())
      catch e
    store.dispatch(setUserAcls(@userAcls))

  clearUserAclPermissions: ->
    @userAcls = []
    store.dispatch(setUserAcls(@userAcls))

  clearProjWriteAccess: ->
    @userAcls = @userAcls.filter((id) -> id isnt WRITE_ACCESS)
    store.dispatch(setUserAcls(@userAcls))

  getProjectAcls: ->
    @projectAcls = (getProjectData().permissions or [])
      .map(({ function_access }) -> function_access)
      .filter((x, i, a) -> a.indexOf(x) is i)
      .flat()

  determineUserAcls: ->
    results = await Promise.allSettled(
      @projectAcls.map(Weaver.ACL.load)
    )
    aclIds = results
      .filter((prom) -> prom.isFulfilled())
      .map((prom) -> prom.value())
      .map((acl) -> acl.id())
    for id in aclIds
      if @userAcls.indexOf(id) is -1 then @userAcls.push(id)
    @userAcls.push(WRITE_ACCESS) if (await @checkHasWriteAccess())
    store.dispatch(setUserAcls(@userAcls))

  determineUserRoles: ->
    roles = await Weaver
      .getInstance()
      .currentUser()
      .getRoles()

    @userRoles = roles.map((r) -> r.id())
    store.dispatch(setUserRoles(@userRoles))

  checkHasWriteAccess: (space = Weaver.getInstance().currentProject()) ->
    return false unless space?
    projAcl = await space.getACL()

    if Weaver.getInstance().currentUser()?
      roles = await Weaver.getInstance().currentUser().getRoles()
      hasRoleWriteAccess = roles.map((role) ->
        projAcl.getRoleWriteAccess(role)
      ).some((canWrite)-> canWrite)
      hasUserWriteAccess = projAcl.getUserWriteAccess(Weaver.getInstance().currentUser())
      hasRoleWriteAccess or hasUserWriteAccess
    else
      false

  hasAclAccess: (aclId) ->
    @userAcls.indexOf(aclId) isnt -1

  hasWriteAccess: ->
    @hasAclAccess(WRITE_ACCESS)

  hasRole: (roleId) ->
    @userRoles.indexOf(roleId) isnt -1

export default new ACL_Service()
